var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
      _vm.$route.name !== 'AdvertiseDetails' && _vm.$route.name !== 'OutsideAdvertise'
    )?_c('Header'):_vm._e(),_c('div',{staticStyle:{"min-height":"calc(100vh - 502px)"}},[_c('router-view')],1),(
      _vm.$route.name !== 'AdvertiseDetails' && _vm.$route.name !== 'OutsideAdvertise'
    )?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }